import React from 'react';

import { useHomeData } from '../components/LoadHomeData/HomeDataProvider';
import { NoAccessToView } from '../components/NoAccessToView/NoAccessToView';
import { useTranslations } from '../components/Translations/TranslationsProvider';
import { ValidateQRScan } from '../components/ValidateQRScan/ValidateQRScan';

export const ValidateQRPage = () => {
    const { translations } = useTranslations();
    const { homepageData } = useHomeData();
    const isGuard = homepageData?.authorizations?.mayUseGuardsMobileFx ?? false;

    return (
        <>
            {!isGuard && <NoAccessToView translations={translations} />}
            {isGuard && <ValidateQRScan translations={translations} />}
        </>
    );
};
